import(/* webpackMode: "eager" */ "/app/apps/web/src/features/CartIconBadge/ui/CartIconBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/SignOut/ui/SignOut.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/favourite.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/package.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/profile.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/sign-out.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/widgets/Sidebar/ui/SidebarLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.25_@babel+core@7.27.4_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.25_@babel+core@7.27.4_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","warning"] */ "/app/node_modules/.pnpm/sonner@1.7.4_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/sonner/dist/index.mjs");
